import * as React from 'react';
import cn from 'clsx';
import { Spinner } from '@cian/ui-kit';

import { FileChose } from './components';

import * as styles from './styles.css';

export interface IFileUploadProps {
  isLoading: boolean;
  name: string;
  buttonText: string;
  descriptionText: string;
  multiple?: boolean;

  onFileSelect(files: FileList | null): void;
}

export const FileUpload: React.FC<IFileUploadProps> = props => {
  const { name, isLoading, onFileSelect, multiple, buttonText, descriptionText } = props;

  return (
    <div className={styles['container']} data-testid="file-upload">
      <div className={cn(styles['loading'], { [styles['hidden']]: !isLoading })} data-testid="file-upload-loading">
        <Spinner size={18} color="primary_100" />
      </div>

      <div className={cn({ [styles['hidden']]: isLoading })} data-testid="file-upload-chose">
        <FileChose
          name={name}
          onFileSelect={onFileSelect}
          multiple={multiple}
          buttonText={buttonText}
          descriptionText={descriptionText}
        />
      </div>
    </div>
  );
};

FileUpload.displayName = 'FileUpload';
